module.exports = __webpack_public_path__ + "img/xk.e62eb493.svg";